import { PageLoadingIndicator } from "@ecologi/react-components/src/PageLoadingIndicator";
import { FC } from "react";
import { usePrivatePageGuard } from "./use-private-page-guard";

type LayoutProps = {
  isProfile?: boolean;
};

/**
 * This guard should be used with caution — any page wrapped in it will have its LCP
 * score (Largest Contentful Paint) heavily negatively impacted, due to the loading
 * screen presented.
 *
 * This is only an issue on first load. If a user navigates to the private page from
 * another Platform page, the loading screen will not be shown.
 */
export function withPrivatePageGuard<T>(
  Component: FC<T>,
  redirectPathOnFailure?: string
) {
  const wrappedComponent = (props: T) => {
    const { isUserAllowedAccess, isLoading } = usePrivatePageGuard(
      redirectPathOnFailure
    );

    if (isLoading) {
      return <PageLoadingIndicator text="Loading user data..." />;
    }

    return isUserAllowedAccess ? <Component {...props} /> : null;
  };

  wrappedComponent.layoutProps = {} as LayoutProps;

  return wrappedComponent;
}
